var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 325.41 40.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5f5041;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.08,19.14a40.29,40.29,0,0,1,6.23-5.51,67.73,67.73,0,0,1,7.06-4.46A75.89,75.89,0,0,1,235,2.93,82.71,82.71,0,0,1,268.7.85a88,88,0,0,1,31.78,11,83.69,83.69,0,0,1,24.93,21.56c-2.63-1-5.1-2-7.56-3.09-1.27-.48-2.49-1-3.72-1.51s-2.41-1.08-3.67-1.51l-3.65-1.45c-.62-.23-1.2-.51-1.81-.73l-1.83-.66c-1.23-.43-2.43-.91-3.62-1.37s-2.45-.79-3.65-1.23a161.15,161.15,0,0,0-29.17-7.19,139.32,139.32,0,0,0-29.83-1A159.1,159.1,0,0,0,206.08,19.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,40.31a39.87,39.87,0,0,1,4.46-7A68.18,68.18,0,0,1,10,27,75.72,75.72,0,0,1,23.25,16.72,82.69,82.69,0,0,1,55.09,5.37,88,88,0,0,1,88.68,7.15,83.66,83.66,0,0,1,118.61,21c-2.79-.18-5.46-.54-8.12-.87-1.35-.12-2.67-.28-4-.42s-2.62-.37-3.94-.44l-3.92-.37c-.65-.05-1.29-.16-1.94-.2l-1.94-.13c-1.3-.07-2.58-.2-3.86-.31s-2.57-.08-3.84-.17a160.89,160.89,0,0,0-30,1.19,138,138,0,0,0-28.93,7.33A158.77,158.77,0,0,0,0,40.31Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset5);
export default __webpack_public_path__ + "static/media/Asset 5.a6447675.svg";
export { ForwardRef as ReactComponent };